export const allowlistAddresses = [
  ["0xdEcf4B112d4120B6998e5020a6B4819E490F7db6",1],
]